import { ComponentType as a } from "../../registries/types/propTypes.js";
const t = (n) => {
  const l = (Array.isArray(n.download_links) ? n.download_links[0] : n.download_links).items.map((o) => ({
    label: o.link.text,
    url: o.link.url,
    target: o.link.target
  }));
  return {
    componentType: a.download_links,
    data: l
  };
};
export {
  t as default
};
//# sourceMappingURL=download-link-transformer.js.map
